import { redirect, type LoaderFunctionArgs } from "react-router-dom";
import { getCountryCodeCookie } from "src/cookies";

export const documentListingLoader = ({
  request,
}: LoaderFunctionArgs): Response | null => {
  const countryCode = getCountryCodeCookie();
  const url = new URL(request.url);

  if (!url.searchParams.get("country") && countryCode) {
    url.searchParams.set("country", countryCode);
    return redirect(`${url.pathname}${url.search}${url.hash}`);
  }

  return null;
};
